import React, {
} from 'react';

// npm install japan-postal-code
// https://www.npmjs.com/package/japan-postal-code?activeTab=readme

import postal_code from 'japan-postal-code';

export default class myJP { // japan postal code

static myJP_getArs = ( // get address
    p_code,
) => new Promise( _o_end1 => {
  postal_code.get(p_code, _ars => {
    let _d = {
      ars1: _ars.prefecture,
      ars2: _ars.city,
      ars3: _ars.area,
      ars4: _ars.street,
    };
    _o_end1(_d);
  });
});

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
